/**
 * Extracts the first letter of a name to be used as an avatar initial.
 *
 * Names come from the API exactly as the person typed them, decorations
 * included — `"Marcrusk (Marco Nunes"`, `"- João"`, `"@ana"`. Reading the raw
 * first character puts a `(` or `-` inside the avatar as if it were an
 * initial, so the first *letter* is what gets picked, skipping punctuation,
 * digits, emoji and whitespace anywhere before it.
 *
 * @param {string | null | undefined} name The name (or name part) to read.
 * @returns {string} The first letter found, or `''` when the name has none —
 * callers should fall back to a generic avatar in that case.
 *
 * @example
 * getNameInitial('Marcrusk'); // 'M'
 * getNameInitial('(Marco Nunes'); // 'M'
 * getNameInitial('(((');  // ''
 */
export function getNameInitial(name: string | null | undefined): string {
  return name?.match(/\p{L}/u)?.[0] ?? '';
}
